<div class="tw-relative tw-min-h-[50dvh] tw-w-full tw-py-12 md:tw-py-24">
  <!-- Imagen de fondo -->
  <div
    class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center"
    style="background-image: url('assets/images/background.png')"
  ></div>

  <!-- Superposición azul translúcida -->
  <div
    class="tw-absolute tw-inset-0"
    style="background: rgba(0, 0, 255, 0.3)"
  ></div>

  <div class="tw-relative tw-z-10 tw-container tw-mx-auto tw-px-6 tw-h-full">
    <div
      class="tw-flex tw-flex-col md:tw-flex-row tw-items-center md:tw-items-center tw-justify-between tw-w-[90%] sm:tw-w-[80%] tw-mx-auto tw-h-full tw-gap-8"
    >
      <!-- Columna de texto -->
      <div class="tw-flex-1 tw-text-center md:tw-text-left">
        <h4
          class="tw-text-xl md:tw-text-3xl lg:tw-text-5xl xl:tw-text-6xl 2xl:tw-text-7xl tw-font-montserrat tw-text-white"
        >
          Escríbenos o llámanos para conectar con
          <span class="tw-text-[#F67011] tw-font-abadi tw-font-bold">
            Onelink
          </span>
        </h4>
      </div>

      <!-- Columna de botones -->
      <div
        class="tw-flex-1 tw-flex tw-flex-col md:tw-items-end tw-items-center tw-gap-4"
      >
        <a
       href="mailto:info@onelink.net.ve"
          class="tw-w-64  tw-decoration-transparent tw-flex tw-items-center tw-justify-center tw-gap-2 tw-bg-orange-500 tw-text-white tw-font-semibold tw-py-4 tw-rounded-full hover:tw-bg-orange-600 tw-shadow-lg tw-transition"
        >
          <i class="bi bi-envelope-fill"></i> Escríbenos
        </a>
        <a
          href="tel:+582813169200"
          class="tw-w-64 tw-decoration-transparent tw-flex tw-items-center tw-justify-center tw-gap-2 tw-bg-orange-500 tw-text-white tw-font-semibold tw-py-4 tw-rounded-full hover:tw-bg-orange-600 tw-shadow-lg tw-transition"
        >
          <i class="bi bi-telephone-fill"></i>
          Llámanos
        </a>
      </div>
    </div>
  </div>
</div>
